import React, { useEffect, useState } from 'react';
import useAllowedEntityQuery from '../../../../queries/useAllowedEntityQuery';
import { useDispatch, useSelector } from 'react-redux';
import { documentsActions } from '../../../../store/actions/documents.actions';
import { getDocOptionsSelect } from '../../../../utils/getDocOptionsSelect';
import { getRenderControl } from '../../../../../../components/SingleControlCustom/getRenderControl';
import DropdownSelect from '../../../../../../components/dropdownSelect';
import styles from './CreateConnection.module.scss';
import RoundedButton from '../../../../../../components/RoundedButton/RoundedButton';
import { actions } from '../../../../store/actions/new-document.actions';

const CreateConnection = () => {
  const dispatch = useDispatch();

  const doc = useSelector(
    (state) => state.documentsStore.relatedDocsModalVisible
  );

  const [value, setValue] = useState(null);

  const { data: allowedEntity = [], isFetching: isAllowedEntityFetching } =
    useAllowedEntityQuery(doc?.type?.id, {
      enabled: !!doc?.type?.id,
      staleTime: Infinity,
    });

  const options = getDocOptionsSelect(allowedEntity);

  const handleClose = () => {
    dispatch(documentsActions.setRelatedDocsModal(null));
  };

  const handleCreateConnection = () => {
    dispatch(actions.openCreateDocumentByRelated({ doc, documentId: doc?.id }));

    handleClose();
  };

  useEffect(() => {
    if (allowedEntity && allowedEntity?.length === 1) {
      setValue(allowedEntity[0].id);
    }
  }, [allowedEntity]);

  return (
    <div className={styles.root}>
      <DropdownSelect
        disabled={isAllowedEntityFetching}
        loading={isAllowedEntityFetching}
        multiple={false}
        options={options}
        onChange={setValue}
        value={value}
        renderControl={getRenderControl({
          options,
          isClear: false,
          value,
        })}
      />
      <RoundedButton
        text="Создать"
        className={styles.createBtn}
        disabled={!value}
        onClick={handleCreateConnection} // сейчас идет связывание только объектов
      />
    </div>
  );
};

export default CreateConnection;
